
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Baixa } from '@app/models/baixa.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { Pagar, PagarListaFiltros } from '@app/models/pagar.model';
import { RealizarPagamento } from '@app/models/realizar-pagamento';
import { PesquisaRelatorio } from '@app/models/pesquisa-relatorio';
import { PagarQuitarDados } from '@app/pages/financeiro/pagar/pagar-lista/pagar-quitar-dados';
import { RateioFaturamentoInput } from '@app/models/rateio-faturamento.model';
import { RateioCriacaoInput } from '@app/models/rateio.model';

@Injectable()
export class PagarService extends ServiceBase {

  constructor(private http: HttpClient) {
    super();
  }

  gravar(pagar: Pagar): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/pagar', pagar).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  editarTituloPago(pagar: Pagar): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/pagar/editarPago', pagar).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  quitar(quitarDados: PagarQuitarDados): Observable<any> {
    return this.http
      .post<boolean>(this.URL_API + 'financeiro/pagar/quitar', quitarDados)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  desquitar(desquitarDados: PagarQuitarDados): Observable<any> {
    return this.http
      .post<boolean>(this.URL_API + 'financeiro/pagar/desquitar', desquitarDados)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `financeiro/pagar/${id}`)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/pagar/${id}`);
  }

  obterLista(filtros: PagarListaFiltros): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/pagar/lista', filtros, { headers: { meta: ['search'] } });
  }

  obterListaProcesso(filtros: PagarListaFiltros): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/pagar/listaProcesso', filtros, { headers: { meta: ['search'] } });
  }

  obterParciais(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/pagar/obterParciais/?id=${(id)}`);
  }

  realizarEstorno(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/pagar/realizarEstorno/?id=${(id)}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  gerarFaturas(id: number, qntParcelas: number, intervaloDias: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/pagar/gerarFaturas/?id=${id}&qntParcelas=${qntParcelas}&intervaloDias=${intervaloDias}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'pagar');
  }

  obterPagamentosValidacao(pagina: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `pagar/obterPagamentosValidacao/?pagina=${(pagina)}`);
  }

  obterPagamentosValidacaoRemovidos(pagina: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `pagar/obterPagamentosValidacaoRemovidos/?pagina=${(pagina)}`);
  }

  realizarPagamento(realizarPagamento: RealizarPagamento): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'pagar/realizarPagamento', realizarPagamento).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  removerDaValidacao(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `pagar/removerDaValidacao/?id=${(id)}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }
  enviarParaValidacao(id: number, jaValidado: boolean): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `pagar/enviarParaValidacao/?id=${(id)}&jaValidados=${jaValidado}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  alterarFormaDePagamentoValidacao(id: number, formaDePagamento: string): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `pagar/alterarFormaDePagamentoValidacao/?id=${(id)}&formaDePagamentoCodigo=${encodeURIComponent(formaDePagamento)}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  realizarAgrupamento(idProcesso: number, valorPago: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API +
        `pagar/realizarAgrupamentoPagamento/?idProcesso=${(idProcesso)}&valorPago=${(valorPago)}`).pipe(
          catchError((error: any) => observableThrowError(error)));
  }

  realizarAgrupamentoSelecionando(ids: number[], formaDePagamento: string): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `pagar/realizarAgrupamentoPagamentoSelecionando/?ids=${(ids)}&formaDePagamento=${encodeURIComponent(formaDePagamento)}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  enviarParaValidacaoDePagamento(ids: number[], formaDePagamento: string): Observable<any> {
    return this.http
      .get<any>(this.URL_API +
        `pagar/enviarParaValidacaoDePagamento/?ids=${(ids)}&formaDePagamento=${encodeURIComponent(formaDePagamento)}`).pipe(
          catchError((error: any) => observableThrowError(error)));
  }

  validarPagamentos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'pagar/validarPagamentos').pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  realizarPagamentoDosValidados(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'pagar/realizarPagamentoDosValidados').pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterTotalPagarPorProcesso(processoId: number, pesquisa: PesquisaRelatorio): Observable<any> {
    pesquisa.ProcessoId = processoId;
    return this.http
      .post<any>(this.URL_API + 'financeiro/processo/obterTotalPagarPorProcesso', pesquisa);
  }


  ObterTodasAsDatasDaValidacao(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `pagar/ObterTodasAsDatasDaValidacao`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  emitirRecibos(listaTitulos: Baixa[]) {
    const newTab = window.open();
    window.localStorage.removeItem('recibos');
    window.localStorage.setItem('recibos', JSON.stringify(listaTitulos));
    newTab.location.href = window.location.href.split('#')[0] + '/#/recibo-multiplo?recibos';
    // history.go(-1);
    // newTab.close();
  }

  obterFaturamentoRateio(filtro: RateioFaturamentoInput){
    return this.http
    .get<any>(this.URL_API + `financeiro/pagar/obterFaturamento/?FaturamentoBase=${filtro.FaturamentoBase}&DataFinal=${filtro.DataFinal}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  gravarRateio(rateio: RateioCriacaoInput){
    return this.http
    .post<any>(this.URL_API + 'financeiro/pagar/rateio', rateio).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

}
